module.exports = "<p>\n  navigator works!\n</p>\n"